import React from 'react';

function Facebook({ size, stroke, fill = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill}
      {...otherProps}
    >
      <path d="M12.8001 9.5998V8.1598C12.8001 7.5358 12.9441 7.1998 13.9521 7.1998H15.2001V4.7998H13.2801C10.8801 4.7998 9.92012 6.3838 9.92012 8.1598V9.5998H8.00012V11.9998H9.92012V19.1998H12.8001V11.9998H14.9121L15.2001 9.5998H12.8001Z" />
    </svg>
  );
}

export default Facebook;
